import React from 'react';
import { useCartCache } from '../context/CartCacheContext';
import Icon from './Icon';

interface CartButtonProps {
  onClick?: () => void;
}

export default function CartButton(props: CartButtonProps) {
  const { onClick } = props;
  const { cart } = useCartCache();

  const allDrafts = cart?.workingDrafts ?? [];

  const classes = ['basic-button relative flex items-center justify-center select-none mr-4'];
  if (onClick) classes.push('cursor-pointer');

  const divClasses = [
    'absolute top-0 right-0 rounded-full text-sm bg-active text-white font-bold',
    'w-6 h-6 flex items-center justify-center outline-none',
  ];

  return (
    <button
      disabled={allDrafts.length < 1}
      onClick={onClick}
      className={classes.join(' ')}
      role={onClick ? 'button' : undefined}
      aria-label="Open cart"
    >
      <Icon icon={['fass', 'cart-shopping']} className="text-active text-4xl" />
      <div
        className={divClasses.join(' ')}
        style={{
          transform: 'translate(75%, -75%)',
        }}
      >
        {allDrafts.length}
      </div>
    </button>
  );
}
